/**
 * The longest value each lead-form field may hold. The Zod schemas
 * (contact.ts, quote.ts, ebook.ts, phone.ts) and the forms' `maxLength`
 * attributes both read these, so the browser stops a visitor at exactly the
 * point the server would refuse them.
 */
export const FIELD_MAX = {
  name: 100,
  email: 200,
  company: 200,
  phone: 40,
  eventCity: 120,
  message: 5_000,
} as const;

/** The compact form's single "Full name" box holds a first and a last name. */
export const FULL_NAME_MAX = FIELD_MAX.name * 2 + 1;

/** Show the message box's characters-left note once this much of it is used. */
export const MESSAGE_NEAR_LIMIT = 4_500;

/** The largest group size the quote schema accepts. */
export const GROUP_SIZE_MAX = 100_000;
